import { WsConfig } from '@ezio/ws'

import { useSocketIo, Socket } from '@ezio/ws'
import { type EzioWs } from './types'

const config: WsConfig = {
    url: import.meta.env.VITE_EZIO_WS_URL
}

let ws: EzioWs = null

export const useEzioWs = () => {
    if (!ws) {
        ws = EzioWs()
    }
    return {
        ws
    }
}

const EzioWs = () => {
    const socketIo = useSocketIo(config)
    let socket: Socket = null
    let tokensStore = null

    const getRequestHeaders = () => {
        console.log('ws: ', tokensStore.tokens)
        return {
            'Access-Token': tokensStore.tokens.accessToken,
            Client: tokensStore.tokens.client,
            Uid: tokensStore.tokens.uid
        }
    }

    const setTokensStore = (value) => {
        tokensStore = value
    }

    const connect = () => {
        return socketIo.connect(getRequestHeaders())
    }

    const on = (eventName: string, callback: any) => {
        if (!socket) {
            socket = connect()
        }
        return socket.on(eventName, callback)
    }

    const off = (eventName: string) => {
        if (socket) {
            return socket.off(eventName)
        }
    }

    return {
        on,
        off,
        tokensStore,
        setTokensStore
    }
}
